import React from "react";
import MatchTypeComponent from "./MatchTypeComponent";
import LabelWithInputDisabled from "../../../components/generic/LabelWithInputDisabled";
import MappingViewLink from "./MappingViewLink";
import "../../../styles/viewDetail.css";

function FileToFileView(props) {
  return (
    <div>
      <MatchTypeComponent
        matchType={props.matchType}
        fileName={props.fileName}
      />
      <LabelWithInputDisabled label="Delimiter" value={props.delimiter} />
      <MatchTypeComponent
        matchType={props.matchTypeTwo}
        fileName={props.fileNameTwo}
      />
      <LabelWithInputDisabled label="Delimiter" value={props.delimiterTwo} />
      <div className="vd-row">
        <span className="vd-label">Mapping</span>
        <span className="vd-value">
          <MappingViewLink
            mappingName={props.mappingName}
            mappingDetail={props.mappingDetail}
          />
        </span>
      </div>
    </div>
  );
}

export default FileToFileView;
